if (!window.Maximize.loadedScript.includes('sticky-free-shipping-bar.js')) {
  window.Maximize.loadedScript.push('sticky-free-shipping-bar.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      const getVisibleText = (el) => {
        const clone = el.cloneNode(true);
        clone.querySelectorAll('style, script').forEach((n) => n.remove());
        return clone.textContent.trim();
      };

      Alpine.data('xStickyFreeShippingBar', (sectionId) => ({
        visible: false,
        init() {
          this.syncFromContent();
          this._boundCartUpdate = (e) => {
            if (e.detail?.isItemCountChanged) this.refresh();
          };
          document.addEventListener(CART_EVENT.cartUpdate, this._boundCartUpdate);

          if (Shopify.designMode) {
            this._boundSectionSelect = (e) => {
              if (e.detail?.sectionId === sectionId) this.visible = true;
            };
            this._boundSectionDeselect = (e) => {
              if (e.detail?.sectionId === sectionId) this.syncFromContent();
            };
            document.addEventListener('shopify:section:select', this._boundSectionSelect);
            document.addEventListener('shopify:section:deselect', this._boundSectionDeselect);
          }
        },
        syncFromContent() {
          const contentEl = document.getElementById(`StickyFreeShippingBar__Content-${sectionId}`);
          this.visible = !!(contentEl && getVisibleText(contentEl).length > 0);
        },
        refresh() {
          fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newContent = doc.getElementById(`StickyFreeShippingBar__Content-${sectionId}`);
              const currentContent = document.getElementById(`StickyFreeShippingBar__Content-${sectionId}`);
              if (currentContent && newContent) currentContent.innerHTML = newContent.innerHTML;
              this.syncFromContent();
            })
            .catch((e) => console.error(e));
        }
      }));
    });
  });
}
